import React from 'react';
import {FormattedMessage} from 'react-intl';
import {Dropdown, Form, Label} from 'semantic-ui-react';
import {any, arrayOf, bool, element, func, number, object, oneOfType, shape, string} from 'prop-types';
import {EmptyFunc} from "../../../utils/DBUtils";

export default class DropdownInput extends React.Component {
  static propTypes = {
    required: bool,
    label: oneOfType([string, element]),
    name: string.isRequired,
    value: any.isRequired,
    text: string,
    options: arrayOf(shape({
      text: string,
      textKey: string,

      // constrained by Dropdown.Item 'value' propType:
      value: oneOfType([string, number, bool])
    })),
    onValueChanged: func.isRequired,
    validationRules: arrayOf(object),
    errors: arrayOf(object)
  };

  static defaultProps = {
    options: [],
    errors: []
  };

  get options() {
    let known = {};
    return this.props.options
        .filter((option) => {
          // remove dups
          if (!known[option.value]) {
            known[option.value] = true;
            return true;
          }
          return false;
        })
        .map(option => (
      <Dropdown.Item
        key={option.value}
        value={option.value}
        onClick={this.props.multiple ? EmptyFunc : this.handleChange}
        content={option.text || <FormattedMessage id={option.textKey} />} />
    ));
  }

  handleChange = (event, {value}) => {
    this.props.onValueChanged(value);
  };

  render() {
    const selectedOption = this.props.options.find(opt => opt.value === this.props.value);
    const text = selectedOption ? (
      selectedOption.text || <FormattedMessage id={selectedOption.textKey} />
    ) : '';

    return (
      <Form.Field>
        {this.props.label}
        <Dropdown
          text={text}
          multiple={this.props.multiple}
          value={this.props.value || null}
          options={this.options}
          selection
          closeOnBlur
          closeOnChange
          onChange={(event, data) => console.log(event, data)}
          openOnFocus={false}
          selectOnBlur={false}
          selectOnNavigation={false} />
        {this.props.errors.map(error => (
          <Label
            basic
            className='db-error-label'
            key={error.type}>
            <FormattedMessage id={`errors.validation.${error.type}`} />&nbsp;
            {error.invalidValues && (
              <FormattedMessage
                id='errors.validation.invalid_values'
                values={{invalidValues: error.invalidValues}} />
            )}
          </Label>
        ))}
      </Form.Field>
    );
  }
};



// WEBPACK FOOTER //
// ./public/components/forms/BasicFormFields/DropdownInput.jsx